import "./DashboardTicker.scss"
import { Card } from "../../../../core/components"
import { useEffect, useRef, useState } from "react"

interface DashboardTickerProps {
    title?: string
    value?: string | number
    icon?: string
    backgroundColor?: string
    containerWidthThreshold?: number
    className?: string
    isSelected?: boolean
    onToggle: (value: boolean) => void
}

export const DashboardTicker : React.FC<DashboardTickerProps> = (props) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const [showIcon, setShowIcon] = useState<boolean>(true)

    useEffect(() => {
        const container = containerRef.current?.parentElement?.parentElement

        if (!container || !container.offsetWidth || !props.containerWidthThreshold)
            return

        const observer = new ResizeObserver(() => {
            if (!container) return

            setShowIcon(container.offsetWidth > (props.containerWidthThreshold || 0))
        })

        observer.observe(container)

        return () => { observer.disconnect() }
    }, [])

    return (
        <Card borderRadius="small" className={`ticker border-light ${props.backgroundColor} ${props.isSelected ? "selected" : ''}`}>
            <div className={`ticker-container `} ref={containerRef} onClick={() =>props.onToggle(true)}>
                {showIcon && <div className={`icon-wrapper`}>
                    <i className={`dx-icon dx-icon-${props.icon}`} />
                </div>}
                <div className="ticker-container-content">
                    <div className='title'>
                        {props.title}
                    </div>
                    <div className='total'>
                        {props.value}
                    </div>
                </div>
            </div>
        </Card>
    )
}
